(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-electroplated-me"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var menuBtn = document.getElementById('lpMenuBtn');
    var links = document.getElementById('lpLinks');
    if(menuBtn && links){
      menuBtn.addEventListener('click', function(){ links.classList.toggle('open'); });
    }
    var y = document.getElementById('lpYear');
    if(y){ y.textContent = new Date().getFullYear(); }

    document.querySelectorAll('.lp a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var id = a.getAttribute('href');
        if(!id || id === '#') return;
        var el = document.querySelector(id);
        if(el){
          e.preventDefault();
          el.scrollIntoView({behavior:'smooth', block:'start'});
          if(links) links.classList.remove('open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
